export const PatientDetailHeader = {
  id: 'システムID',
  username: 'ユーザID',
  birthdayYmd: '生年月日',
  createdAt: '作成日',
  gender: '性別',
  hospitalIds: '所属医療機関ID',
  heartRate:  '安静時心拍数'
};

export const HospitalDetailHeader = {
  id: 'ID',
  createdAt: '作成日',
  name: '医療機関名'
};

export const DoctorDetailHeader = {
  id: 'ID',
  createdAt: '作成日',
  username: 'ユーザ名',
  name: '医師名'
};



// WEBPACK FOOTER //
// ./src/constants/UserDetails.tsx